export function getArticlePriceData(article: any) {
  const inventory = article.inventory && article.inventory[0];

  const basePrice = inventory && inventory.basePrice;
  const salePrice = inventory && inventory.salePrice;
  const finalPrice = basePrice ? (salePrice ? salePrice : basePrice) : 0;
  const discount = basePrice - finalPrice;
  const discountPercentage = (discount / basePrice) * 100;
  const taxRate = inventory && inventory.taxRate;

  return {
    basePrice,
    salePrice,
    finalPrice,
    discount,
    discountPercentage,
    taxRate,
  };
}
